import './App.css';
import { Routes, Route, useLocation } from 'react-router-dom';

import Footer from './components/footer/footer';
import Navbar from './components/navbar/navbar';

import HomePage from './pages/home/HomePage';
import ResourcesPage from './pages/resources/ResourcesPage';
import ServicesPage from './pages/services/ServicesPage';
import KitsPage from './pages/kits/KitsPage';
import TechnologyPage from './pages/technology/TechnologyPage';
import ContactPage from './pages/contact/ContactPage';
import ServicePage from './pages/services/service/ServicePage';
import ScisCloudPage from './pages/sciscloud/ScisCloudPage';
// import MachineLearningPage from './pages/machine-learning/MachineLearningPage';

import { service_cards } from './database/homepage/services-cards';
import { publications } from './database/publications';
import { resources } from './database/resources';
import { headers } from './database/headers';
import { services } from './database/services';
import { kits } from './database/kits';
import { createTheme } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import TermsOfUsePage from "./pages/terms-of-use/TermsOfUse";
import PrivacyPolicyPage from "./pages/privacy-policy/PrivacyPolicyPage";
// import DocumentationPage from "./pages/documentation/DocumentationPage";
// import AboutPage from './pages/about/AboutPage';

function App() {
  // MUI theming
  const theme = createTheme({
    palette: {
      primary: {
        // orange with white text
        main: '#f47d21',
        contrastText: '#FFFFFF',
      },
      secondary: {
        // transparent, white text
        main: 'rgba(0, 0, 0, 0)',
        contrastText: '#FFFFFF',
      },
    },
    // MUI's 14px button text scaled by 1.25, in step with the site-wide
    // small-text bump (and the Services page's Learn more button).
    typography: {
      button: {
        fontSize: '17.5px',
      },
    },
  });

  /** Functions to ensure navigation links go back to top of page */

  const [navBg, setNavBg] = useState(false);
  const isHome = true;

  const changeNavBg = (e) => {
    window.scrollY >= 100 ? setNavBg(true) : setNavBg(false);
  };

  useEffect(() => {
    window.addEventListener('scroll', changeNavBg);
    return () => {
      window.removeEventListener('scroll', changeNavBg);
    };
  }, []);

  /** If hash link, scroll to correct location */
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    // if not a hash link, scroll to top
    if (hash === '') {
      window.scrollTo(0, 0);
    }
    // else scroll to id
    else {
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView();
        }
      }, 0);
    }
  }, [pathname, hash, key]);

  return (
    <main className='App'>
      <Navbar
        {...(isHome && navBg ? { backgroundColor: 'white' } : {})}
        theme={theme}
      />
      <Routes>
        <Route
          path='/*'
          element={
            <HomePage
              service_cards={service_cards}
              publications={publications}
              theme={theme}
            />
          }
        />
        <Route
          path='/services/*'
          element={
            <ServicesPage headers={headers} services={services} theme={theme} />
          }
        />
        <Route
          path='/kits/*'
          element={<KitsPage headers={headers} kits={kits} />}
        />
        <Route
          path='/technology/*'
          element={<TechnologyPage headers={headers} theme={theme} />}
        />
        <Route
          path='/sciscloud/*'
          element={<ScisCloudPage headers={headers} theme={theme} />}
        />
        {/* <Route
          path='/machine-learning/*'
          element={<MachineLearningPage headers={headers} />}
        /> */}
        <Route
          path='/resources_&_publications/*'
          element={
            <ResourcesPage
              resources={resources}
              publications={publications}
              headers={headers}
              theme={theme}
            />
          }
        />
        {/* <Route
          path='/about'
          element={
            <AboutPage
              headers={headers}
              theme={theme}
            />
          }
        /> */}
        <Route
          path='/contact/*'
          element={<ContactPage headers={headers} theme={theme} />}
        />
        <Route
          path='/services/:id'
          element={<ServicePage headers={headers} services={services} />}
        />

        <Route
          path='/terms-of-use'
          element={<TermsOfUsePage headers={headers}/>}
        />
        {/* <Route
          path='/documentation/*'
          element={<DocumentationPage headers={headers} />}
        /> */}
        <Route
          path='/privacy-policy'
          element={<PrivacyPolicyPage headers={headers}/>}
        />
      </Routes>
      <Footer />
    </main>
  );
}

export default App;
